<template>
	<div>
		<div v-if="term==-1">
			<layout-1
			:table_name="tableName"
			:id=pageid1
			:searchbar=false
			:navbar=false
			:button_perm="'20'"
			:button_name="'Select'"
			v-on:select="select"
			:term=[-1,statusGroup]
			:termchange=true
			style="width:100%; height:calc(100vh - 50px);"
			></layout-1>
		</div>
		<div v-else>
			<layout-1
			:table_name="tableName"
			:id=pageid1
			:searchbar=true
			:use_limit=false
			:separateSearch=true
			:navbar=false
			:term=[searchTerm,statusGroup]
			:termchange=true
			:useStatusSearch=true
			:button_perm="'20'"
			:button_name="'Select'"
			:reroute="'/0601'"
			:select_reroute=true
			style="width:100%; height:calc(100vh - 85px);"
			></layout-1>
			<button class="nav-bar" v-on:click="cancel()">Cancel</button>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
	props:{
		term: {
			type: Number,
			required: false,
			default: -1
		},
	},
	data(){
		return{
			pageid1:PAGES.STATUS_REPORTS_PAGE,
			pageid2:PAGES.STATUS_GROUP_PAGE,
			tableName:'Status',
			searchTerm:'',
			statusGroup:0,
		}
	},
	async created(){
		this.statusGroup=api.getCookie('statusGroup')
		this.setTableName();
	},
	methods:{
		select(value){
			router.push('/0601?q='+value[0]+';'+value[1]);
			router.go();
		},
		cancel(){
			router.go(-1);
		},
		setTableName(){
			if(this.term.toString().split(';')[1]!=null){
				this.tableName = this.term.split(';')[1];
				this.searchTerm = this.term.split(';')[0];
			}else{
				if(this.statusGroup==0){
					this.tableName = 'Status';
				}else{
					api.postData(
						{
							type:"search",
							data:{
								pageid:this.pageid2
							}
						}
					).then((res) => {
					   this.tableName = res.data.data.column_data[this.statusGroup-1][0];
					});
				}
			}

		}
	},
	watch:{
		term(){
			this.setTableName();
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/Status.vue